import { ERacingSportSideBarTabs } from 'interfaces/racing';

export const AtoZMenuDefaultConfigs = {
  fit: 'cover',
  aToZRacingSportsList: [ERacingSportSideBarTabs.All],
  languages: [
    {
      prefix: 'en',
      title: 'English',
      region: 'United States',
      language: 'en-us',
      urlPrefix: `${window.location.origin}/en`
    },
    {
      prefix: 'ru',
      title: 'Russian',
      region: 'Worldwide',
      language: 'ru',
      urlPrefix: `${window.location.origin}/ru`
    },
    {
      prefix: 'mn',
      title: 'Mongolian',
      region: 'Worldwide',
      language: 'mn',
      urlPrefix: `${window.location.origin}/mn`
    }
  ],
  showLangSwitcher: true,
  selectCurrentPage: true,
  categoryIds: '',
  moduleId: '521',
  type: 'live',
  category: 'sport',
  limit: 5,
  casinoGamesLimit: 16,
  showCategoryName: 1,
  outRightEnabledAToZ: true,
  todayEventsEnabledAToZ: true,
  boostedOddsEnabledAToZ: true,
  multiplesEnabledAToZ: true,
  sliderArrowsAToZ: true,
  couponBuilderAToZ: true,
  BBAToZ: true
};
